import { CardActions, styled } from '@mui/material';

export const StyledCardActions = styled(CardActions)(({ theme }) => ({
  padding: theme.spacing(2),
}));
